import axios from 'axios';
import lib from '@/lib';

export default class ProfileModel {
	constructor() {
		this.playerProfileEditDescriptionShow = false;
		this.manageSitterAndDualsShow = false;
		this.getExternalLoginShow = false;
		this.startDeletionShow = false;
	}
}
